import {
    IonCard,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
} from "@ionic/react";
import React from "react";
import { Page, settingsOptions } from "../../interfaces/Page";

const SettingsList: React.FC = () => {

    return (
        <IonCard className="bg-white ion-padding">
            <IonList className="bg-white">
                {settingsOptions.map((page: Page, index: number) => (
                    <IonItem 
                        key={index} 
                        detail={true}
                        routerLink={page.path} 
                        routerDirection="none"
                    >
                        <IonIcon icon={page.icon} slot="start" />
                        <IonLabel>
                            <h2>{page.title}</h2>
                            <p>{page.description}</p>
                        </IonLabel>
                    </IonItem>
                ))}
            </IonList>
        </IonCard>
    );
};

export default SettingsList;